import { useEffect } from "react";
import { useLocation } from "wouter";
import { registerBrowserTools } from "@/lib/webmcp";
export function useAgentTools(carId?:number) {
  const [location]=useLocation();
  useEffect(()=>registerBrowserTools(carId),[carId,location]);
}
